module.exports = __webpack_public_path__ + "static/media/Shen.b1b03968.png";